import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {useConstructionPhotosUnlockChoice} from "../../offer/hooks/use_construction_photos_unlock_choice";
import {OfferModalActiveTab} from "../../offer/types/OfferModalActiveTab";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {IPropertyDetailOffer} from "../types/IPropertyDetailOffer";

interface IUsePropertyConstructionStagesClickParams {
    offer: IPropertyDetailOffer;
    propertyId: number;
    changeModalTab: (tab: OfferModalActiveTab, source?: GTMEventApplicationSourceSection) => void;
}

export const usePropertyConstructionStagesClick = ({offer, propertyId, changeModalTab}: IUsePropertyConstructionStagesClickParams) => {
    const {startConstructionPhotosUnlockChoice} = useConstructionPhotosUnlockChoice(offer);

    return () => {
        trackAmplitudeButtonClick({
            buttonName: "view_construction_stages",
            value: "see_construction_stages",
            buttonCategory: "property_page",
            itemId: offer.id,
            propertyId
        });
        changeModalTab(OfferModalActiveTab.CONSTRUCTION_GALLERY, GTMEventApplicationSourceSection.BANNER);
        startConstructionPhotosUnlockChoice();
    };
};
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {useConstructionPhotosUnlockChoice} from "../../offer/hooks/use_construction_photos_unlock_choice";
import {OfferModalActiveTab} from "../../offer/types/OfferModalActiveTab";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {IPropertyDetailOffer} from "../types/IPropertyDetailOffer";

interface IUsePropertyConstructionStagesClickParams {
    offer: IPropertyDetailOffer;
    propertyId: number;
    changeModalTab: (tab: OfferModalActiveTab, source?: GTMEventApplicationSourceSection) => void;
}

export const usePropertyConstructionStagesClick = ({offer, propertyId, changeModalTab}: IUsePropertyConstructionStagesClickParams) => {
    const {startConstructionPhotosUnlockChoice} = useConstructionPhotosUnlockChoice(offer);

    return () => {
        trackAmplitudeButtonClick({
            buttonName: "view_construction_stages",
            value: "see_construction_stages",
            buttonCategory: "property_page",
            itemId: offer.id,
            propertyId
        });
        changeModalTab(OfferModalActiveTab.CONSTRUCTION_GALLERY, GTMEventApplicationSourceSection.BANNER);
        startConstructionPhotosUnlockChoice();
    };
};
